module.exports = __webpack_public_path__ + "static/media/SentToMobile.662b6254.svg";